import { useTradingListingsQuery, useEditListingMutation, MarketListing } from '@http';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import { useState } from 'react';

interface EditListingProps {
  listing: MarketListing;
  onClose?: () => void;
}

export function EditListing({ listing, onClose }: EditListingProps) {
  const [price, setPrice] = useState(listing.price);

  const { t } = useTranslation(undefined, { keyPrefix: 'PlayerMarket.Edit' });
  const { t: tItems } = useTranslation(undefined, { keyPrefix: 'Items' });
  const { mutateAsync: editAsync } = useEditListingMutation();
  const { data: listings } = useTradingListingsQuery();
  const { isFetching, setIsFetching } = useAppStore();
  const queryClient = useQueryClient();

  const total = Number.isFinite(price) ? price * listing.amount : 0;
  const recommendedPrice = (listings ?? [])
    .filter(l => l.key === listing.key)
    .sort((a, b) => a.price - b.price)[0]?.price ?? 0;

  const edit = async () => {
    if (isFetching) return;
    setIsFetching(true);

    await editAsync({ id: listing.id, price });
    onClose?.();

    queryClient.invalidateQueries({ queryKey: ['tradingListings'] });
    setIsFetching(false);
  };

  const canEdit = price > 0;

  return (
    <div className="p-2">
      <p>{tItems(listing.key)}</p>

      <label className="text-sm">{t('price')}</label>
      <input
        onChange={e => setPrice(parseInt(e.target.value))}
        className="input border border-secondary"
        type="number"
        value={price}
      />

      <p className="text-lime-500 text-sm mt-1">
        {t('total', { total, recommendedPrice })}
      </p>

      <Button disabled={!canEdit} className="mt-6" onClick={edit}>
        {t('edit')}
      </Button>
    </div>
  );
}